import React from 'react';
import { reduxForm } from 'redux-form';

import RoomClassFilterSelect from './elements/RoomClassFilterSelect';

const FiltersForm = (props) => {
  const {
    groupAvailData,
    configData,
    selectedRoomClassCodes,
    setSelectedRoomClassCodes,
    isFormBarExpanded,
  } = props;

  return (
    <form className="bk-flow-room__filters-form">
      <RoomClassFilterSelect
        configData={configData}
        groupAvailData={groupAvailData}
        selectedRoomClassCodes={selectedRoomClassCodes}
        setSelectedRoomClassCodes={setSelectedRoomClassCodes}
        isFormBarExpanded={isFormBarExpanded}
      />
    </form>
  );
};

export default reduxForm({
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true,
})(FiltersForm);



// WEBPACK FOOTER //
// ./src/components/forms/filtersForm/FiltersForm.js